// @flow

import React from 'react'

type Props = {
  onKeyPress?: Function,
  onChange: Function,
  onBlur?: Function,
  className?: string,
  borderClass?: string,
  inputClass?: string,
  disabled?: boolean,
  readOnly?: boolean,
  maxLength?: number,
  name?: string,
  placeholder?: string,
  ref?: string,
  required?: boolean,
  type?: string,
  value?: string,
  icon?: any,
}

const OpinaryInput = ({
  onChange,
  onBlur,
  className = '',
  borderClass = 'b--moon-gray',
  inputClass = '',
  disabled = false,
  readOnly = false,
  maxLength,
  name,
  placeholder,
  ref,
  required = false,
  type = 'text',
  value,
  icon,
  onKeyPress,
}: Props) => {
  return (
    <div className={`flex bb ${className} ${borderClass}`}>
      <input
        type={type}
        onKeyPress={onKeyPress}
        className={`h2 bg-transparent dark-gray flex-auto ${inputClass}`}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        name={name}
        required={required}
        maxLength={maxLength}
        ref={ref}
      />
      {icon}
    </div>
  )
}

export default OpinaryInput



// WEBPACK FOOTER //
// ./src/components/Controls/OpinaryInput.js